import { render, staticRenderFns } from "./report-child12.vue?vue&type=template&id=55dcf8dc&scoped=true&"
import script from "./report-child12.vue?vue&type=script&lang=ts&"
export * from "./report-child12.vue?vue&type=script&lang=ts&"
import style0 from "./report-child12.vue?vue&type=style&index=0&id=55dcf8dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcf8dc",
  null
  
)

export default component.exports